import { render, staticRenderFns } from "./Pinyin.vue?vue&type=template&id=6c244060&scoped=true&"
import script from "./Pinyin.vue?vue&type=script&lang=js&"
export * from "./Pinyin.vue?vue&type=script&lang=js&"
import style0 from "./Pinyin.vue?vue&type=style&index=0&id=6c244060&lang=scss&scoped=true&"
import style1 from "./Pinyin.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c244060",
  null
  
)

export default component.exports